/**
 * plugins/index.js
 *
 * Included in `./src/main.js`
 */

// Plugins
import { createVuetifyInstance } from "./vuetify";
import { createPhoneInput } from "./phone-input";
import { createI18n } from "./i18n";
import { createValidator } from "./validator";
import { createOfetch } from "./ofetch";
import { createSentry } from "./sentry";
import { createStaleBuildGuard } from "./staleBuild";
import { createStores } from "@/stores";
import { createRouter } from "@/router";

/**
 *
 * @param {import("vue").App<Element>} app
 */
export async function registerPlugins(app) {
  const stores = createStores();
  app.use(stores);
  await useSettingsStore().loadSettings();

  const i18n = await createI18n();
  app.use(i18n);

  app.provide("vuetifyUseDialogOptions", {
    confirmDialog: { title: i18n.global.t("common.confirmTitle"), cancellationButtonProps: { variant: "text", color: "grey" } },
  });

  const validator = await createValidator(i18n);
  app.use(validator);

  const ofetch = createOfetch(i18n);
  app.use(ofetch);

  const router = createRouter();
  app.use(router);

  const vuetify = createVuetifyInstance(i18n);
  app.use(vuetify);

  const phoneInput = createPhoneInput(i18n);
  app.use(phoneInput);

  if (import.meta.env.PROD) {
    const staleBuildGuard = createStaleBuildGuard(router);
    app.use(staleBuildGuard);

    const sentry = createSentry(router);
    app.use(sentry);
  }
  return app;
}
